import { gql } from '@anyx/common-graphql';

export const MD_STORE_CHANNELS = gql(/* GraphQL */ `
  query MdStoreChannels($mdStoreId: Long!) {
    MdStore(id: $mdStoreId) {
      channels {
        id
        type
      }
    }
  }
`);
